//如需按需加载需要 升级为webpack2  使用import()
import Root from "./pages/root/root.js";
import NotFound from './pages/404/404.js';
import ErrorPage from "./pages/errorPage";
import Search from "./pages/search";
import BookList from "./pages/bookList";
import Read from "./pages/read";


// route页面 务必前面加 /page/
export default {
    root: {
        Root,
        baseUrl: '/page',
        routes: [
            {
                path: '/search',
                name: 'search',
                component: Search,
                exact: true,
                render: null,
                children: null,
            },
            {
                path: '/book-list',
                name: 'book-list',
                component: BookList,
                exact: true,
                render: null,
                children: null,
            },
            {
                path: '/read',
                name: 'read',
                component: Read,
                exact: true,
                render: null,
                children: null,
            },
            {
                path: '/404',
                name: '404',
                component: NotFound,
                exact: true,
                render: null,
                children: null,
            },
        ],
    },
    NotFound,
    ErrorPage,
}




